import { USER_RIGHTS_KEYS } from 'utils/constants';
import { checkIfRightsAssignedTo, getModuleBySlug } from 'utils/helper';
import { useAuthContext } from './useAuthContext';

const { READ, CREATE, UPDATE, DELETE } = USER_RIGHTS_KEYS;

const useGetUserRights = ({ slug = '', right = '', multipleRights = [] }) => {
  const { user } = useAuthContext();

  const userAssignedModules = user?.modules ?? [];
  const currentModule = getModuleBySlug(userAssignedModules, slug);

  const hasRightAccessToRead = checkIfRightsAssignedTo(currentModule?.rights, READ);
  const hasRightAccessToCreate = checkIfRightsAssignedTo(currentModule?.rights, CREATE);
  const hasRightAccessToDelete = checkIfRightsAssignedTo(currentModule?.rights, DELETE);
  const hasRightAccessToUpdate = checkIfRightsAssignedTo(currentModule?.rights, UPDATE);

  const getCurrentRight = (rightValue) => {
    switch (rightValue) {
      case CREATE:
        return hasRightAccessToCreate;
      case READ:
        return hasRightAccessToRead;
      case UPDATE:
        return hasRightAccessToUpdate;
      case DELETE:
        return hasRightAccessToDelete;
      default:
        return false;
    }
  };

  const getMultipleRights = (rights = []) =>
    rights?.length > 0
      ? rights?.some((rightName) => checkIfRightsAssignedTo(currentModule?.rights, rightName))
      : false;

  const hasCurrentRightAccess = getCurrentRight(right);

  const hasMultipleRightAccess = getMultipleRights(multipleRights);

  return {
    userRights: {
      hasRightAccessToCreate,
      hasRightAccessToRead,
      hasRightAccessToUpdate,
      hasRightAccessToDelete,
    },
    hasCurrentRightAccess,
    hasMultipleRightAccess,
  };
};

export default useGetUserRights;
